import { render, staticRenderFns } from "./TheLeftBar.vue?vue&type=template&id=f3dc106a&scoped=true"
import script from "./TheLeftBar.vue?vue&type=script&lang=js"
export * from "./TheLeftBar.vue?vue&type=script&lang=js"
import style0 from "./TheLeftBar.vue?vue&type=style&index=0&id=f3dc106a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dc106a",
  null
  
)

export default component.exports